import { formatDateTime, DATE_FORMATS } from '@belong/common';
import classNames from 'classnames/bind';
import { Text } from 'design-system';
import { legacyParse } from 'forkedlibraries/date-fns-upgrade';
import PropTypes from 'prop-types';
import { PhinCelebration } from 'accounts/components/phin-celebration/phin-celebration';
import styles from './DisplayDefaultEvent.module.css';

const cx = classNames.bind(styles);

const DisplayDefaultEvent = ({
  name,
  date,
  hideDate,
  eyebrow,
  celebrate,
  adornment,
}) => {
  const formattedDate = formatDateTime({
    dateTime: legacyParse(new Date(date)),
    format: DATE_FORMATS.FULL_MONTH_DAY_YEAR,
  });

  const content = (
    <div className={cx('event-container', { single: hideDate })}>
      {eyebrow && (
        <Text fontSize="p1" color="dark-gray">
          {eyebrow}
        </Text>
      )}
      <Text fontWeight={eyebrow ? 'semibold' : undefined}>
        {name}
        {adornment}
      </Text>
      {!hideDate && (
        <Text fontSize="p1" color="dark-gray">
          {formattedDate}
        </Text>
      )}
    </div>
  );

  if (!celebrate) return content;

  return (
    <div className={cx('celebrate-row')}>
      <PhinCelebration />
      {content}
    </div>
  );
};

DisplayDefaultEvent.propTypes = {
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  hideDate: PropTypes.bool,
  eyebrow: PropTypes.string,
  celebrate: PropTypes.bool,
  adornment: PropTypes.node,
};

export default DisplayDefaultEvent;
